<!--
*****************************************************************************
*File : Login.vue
*Module : Dashboard Frontend
*Purpose : Display the login page 
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-container
    id="login"
    fill-height
    tag="section"
  >
  
    <v-row justify="center">
    
        <v-card
          class="mt-6 mt-md-0"
          light
          max-width="100%"
          width="350"
        >
          <v-card-text class="text-center">
            
            <v-avatar
              class="mt-n12 mb-8 elevation-12"
              color="white"
              style="width:80px;height:80px;object-fit:contain;border-radius:2px"
            >
              <v-img class="" src="../../assets/images/DFCCIL_logo.png" height="40"  style="box-shadow:none"/>
            </v-avatar>
            
            <div v-if="error" class="red--text text-center font-weight-bold subtitle-1">{{error}}</div>
            <div class="display-2 font-weight-bold mb-3 text--darken-2 grey--text">
              MVIS
            </div>
            
            <v-text-field class="mb-2" v-model="useremail" name="useremail"
                v-validate="'required'"
                color="secondary"
                data-vv-name="useremail"
                label="Enter your email*"
                prepend-icon="mdi-email"
                validate-on-blur
                :rules="emailRules" 
            />
            <v-text-field class="mb-8" v-model="userpwd" name="userpwd"
                v-validate="'required'"
                :error-messages="errors.collect('account.password')"
                color="secondary"                
                data-vv-name="password"
                label="Enter your password*"
                :prepend-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPwd ? 'text' : 'password'"
                :rules="passwordRules"
                @click:prepend.prevent="showPwd = !showPwd"
                validate-on-blur
            />
        
            <v-btn color="success" default rounded @click="validate()">
              Login
            </v-btn>
          
          </v-card-text>
          <v-spacer/><br>
          
          <hr>
          <div class="aligned">
            <span class=" font-weight-bold text--darken-2 grey--text ml-n2" style="font-size: 14px;">Developed By</span>
            <a href="https://www.iisc.ac.in" target="_blank" >
             <v-img class="" src="../../assets/images/IISc_logo.png"  style="width:90px;object-fit:contain;height:50px;display:block !important"/>
            </a>
            <a href="https://www.l2mrail.com" target="_blank" >
             <v-img class="" src="../../assets/images/L2M-Logo.png"  style="width:140px;object-fit:contain;height:50px;display:block !important"/>
            </a>
          </div>


        </v-card>
        <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
       
        <v-card-title class="text-h5 text-red">
        Session Timeout !
        
        </v-card-title>

        <v-card-text class="center text-red text-h6" align="center">
            Please Login Again 
        </v-card-text>

        <v-card-actions >
          
          
          <v-btn
            color="green darken-1"
            text
          
            @click="dialog = false"
            class="text-h5 text-center"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
        </v-dialog>

        <v-dialog
      v-model="dialogToken"
      max-width="290"
    >
      <v-card>
       
        <v-card-title class="text-h5 text-red">
        Token has expired !
        
        </v-card-title>

        <v-card-text class="center text-red text-h6" align="center">
            Please Login Again 
        </v-card-text>

        <v-card-actions >   
          
          
          <v-btn
            color="green darken-1"
            text
          
            @click="dialogToken = false"
            class="text-h5 text-center"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
        </v-dialog>

    </v-row>
    

  </v-container>  
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Api from '@/views/service/api'
import { router } from '@/router';
import ApiResponse from '../service/api-response'

  export default {
    name: 'DashboardFormsValidationForms',

    $_veeValidate: {
      validator: 'new'
    },

    data() {
      return {
      check : '',
      useremail: '',
      userpwd: '',
      required: '',
      showPwd: false,
      error: '',
      username: '',
      dialog: false,
      dialogToken: false,
      user_ip: '',
      dialogForgot: false,
      resetpwd: '',
      resetemail: '',
      emailRules: [
        v => !!v || 'Email is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      pwddisabled :1,
      cpwddisabled :0,
      displaySwitch:false,
      switch1:false,
      switch2: false,
      emaildisabled: 1,
      showEmail: false,
      firstname: '',
      lastname: '',
      passwordRules: [
        (value) => !!value || 'Please type password.',
        (value) => (value && value.length >= 8) || 'minimum 8 characters',
      ],
      }
    },
    created(){

        let showPopup=window.localStorage.getItem("isLoggedOutFromSession")
        let tokenPopup = window.localStorage.getItem("isTokenExpired");

        if(showPopup == true || showPopup == "true"){
          this.dialog = true
          window.localStorage.removeItem("isLoggedOutFromSession")
        }
        if(tokenPopup == true || tokenPopup == "true"){
          this.dialogToken = true
          window.localStorage.removeItem("isTokenExpired")
        }
        
    },
    methods: {

      togglePassword(){
        if(this.switch2==true){
          this.pwddisabled=0;
        }else{
          this.password=""
          this.confirmpwd=""
          this.pwddisabled=1;
        }
      },

      toggleEmail(){
        if(this.switch1==true){
          this.emaildisabled=0;
        }else{
          this.email="";
          this.emaildisabled=1;
        }
      },

      saveDetails() {
        if(this.firstname || this.lastname) {
          
          Api().post('/api/auth', {
            firstname: this.firstname,
            lastname: this.lastname,
            resetEmail: this.resetemail,
            resetPwd: this.resetpwd,
          }).then(response => {
            console.log(response.data);
          }).catch(error => {
            ApiResponse.checkErrorCode(error.response.status);
          })
        }
        this.resetemail = '';
        this.resetpwd = '';
        this.dialogForgot = false;
        this.switch1 = false;
        this.firstname = '';
        this.lastname = '';
      },

      checkLoginState () {
          this.check = setInterval(() => {
          let authState=window.localStorage.getItem("loggedInUser")
          

          if(authState == false || authState == "false"){
            //Do Nothing
          }else{
           
           this.$router.push({ name: 'Dashboard', params: { } }).catch(()=>{})
           clearInterval(this.check)
          }
        }, 600)
      },
      validate() {
	      window.localStorage.clear();
        this.username = '';
        Api().post('/api/auth', {
          useremail: this.useremail,
          userpwd: this.userpwd,
         
        }).then(response => {    
              
          let active = response.data['loggedUser'][0]['active'];
          this.user_ip = response.data.user_ip;
          this.$store.state.user_ip = this.user_ip;

          let dashboardRoute = 'Dashboard';
          
          if(response.data.passwordMatched == 1 && active) {            
            this.$store.state.logUser = response.data.loggedUser
            this.$store.state.logUserAdmin = this.$store.state.logUser[0].roles;
            window.localStorage.setItem('loggedInUser', true)
            if((router.app.$store.state.logUserAdmin).includes("Admin") == true) {
              this.$store.state.logUserAdmin = "Admin"
              this.$store.state.logUserType = "Admin"
            }
            else if((this.$store.state.logUserAdmin).includes("Supervisor") == true) {
              this.$store.state.logUserCCA = "Supervisor"
              this.$store.state.logUserType = "Supervisor"
            }
            else if((this.$store.state.logUserAdmin).includes("Corporate Office") == true) {
              this.$store.state.logUserCCA = "Corporate Office"
              this.$store.state.logUserType = "Corporate Office"
            }
            else if((this.$store.state.logUserAdmin).includes("Manager") == true) {
              dashboardRoute = 'DashboardManager';
              this.$store.state.logUserCCA = "Manager"
              this.$store.state.logUserType = "Manager"
            }
            else if((this.$store.state.logUserAdmin).includes("Executives") == true) {
              this.$store.state.logUserCCA = "Executives"
              this.$store.state.logUserType = "Executives"
            }
            else if((this.$store.state.logUserAdmin).includes("General User") == true) {    
              this.$store.state.logUserAdmin = "General User"
              this.$store.state.logUserType = "General User"
            }
            
          }
          
          else {
            this.$store.state.logUser = null;
              this.error = "Username or password is incorrect.";
          }
	
	Api().post('/api/token/', {
            username: response.data.loggedUser[0].username,
            password: this.userpwd,
          }).then(response => {
            this.$store.state.token = response.data.access;
            window.localStorage.setItem('userToken', response.data.access);
            this.$router.push({ name: dashboardRoute , params: { } })
          }).catch(error => {
            ApiResponse.checkErrorCode(error.response.status);
          })

        }).catch(error => {
          ApiResponse.checkErrorCode(error.response.status);
        })
      }
    }
    }

</script>
<style lang="scss">
  .l2m-logo {
    position:relative;
    bottom: 0px;
    margin-left: auto;
    margin-right: auto;
  }

 .jsw-logo {
    position:relative;
    left: 0px;
    float: left;
    bottom: 0px; 
  }
  .aligned{
    display: flex;
    align-items: center;
    margin-left: 5%;
    margin-right: 5%;
    
  }
  .text-red{
    color:red;
    font-weight: 500 !important;
  }
  .text-center {
    margin-left: auto;
    margin-right: auto;
    font-weight: 600 !important;
  }
 
  @media only screen and (max-width: 600px) {
  .l2m-logo {
    position:relative;
    right: 0px;
    bottom: 0%;
  }
  .jsw-logo {
    position:relative;
    left: 0px;
    float: left;
    bottom: 0px; 
  }
  }
</style>
